module.exports = __webpack_public_path__ + "img/index_ban3.118470f8.png";